import {Alert, type AlertColor, Snackbar} from "@mui/material";

export type BaseAlert = {
    severity: AlertColor;
    message: string | null;
};

type Props = {
    show: boolean;
    onClose: (() => unknown) | null | undefined;
    autoHideDuration?: number;
    severity: AlertColor;
    message: string | null;
};

const GlenSnackBar = ({show, onClose, autoHideDuration, severity, message}: Props) => {
    return (
        <Snackbar
            open={show && message !== null}
            autoHideDuration={autoHideDuration ?? 10_000}
            onClose={onClose ?? undefined}
        >
            <Alert
                onClose={onClose ?? undefined}
                severity={severity}
                variant="filled"
                sx={{width: "100%"}}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default GlenSnackBar;
